import * as React from "react";
import Divider from 'material-ui/Divider';
import {
    Card,
    CardText,
    Paper,
} from 'material-ui';

import SongCardHeader from './SongCardHeader';
import SongCardBody from './SongCardBody';
import SongCardActions from './SongCardActions';

const SongCardFooter = ({votes, comments, remixes}) => (
    <CardText>{votes} votes • {comments} comments • {remixes} remixes</CardText>
);

const TrackCardFooter = ({votes, comments}) => (
    <CardText>{votes} votes • {comments} comments</CardText>
);

interface ISongCardProps
{
    song : any;
    type : string;
    upVote (id : string) : void
    downVote (id : string) : void
}

class SongCard extends React.Component<ISongCardProps, any> {
    render() {
        const description = this.getDescription();

        const href = this.getHref();

        return (
            <Paper zDepth={1} style={{margin: '0.5em'}}>
                <Card>
                    <SongCardHeader
                        songViews={this.props.song.views}
                        songCreatedAt={this.props.song.createdAt}
                        songAuthorUsername={this.props.song.createdBy.username}
                        songAuthorPicture={this.props.song.createdBy.picture}
                    />
                    <Divider/>
                    <SongCardBody
                        songName={this.props.song.name}
                        songDescription={description}
                        songInstruments={this.props.song.instruments}
                        songTags={this.props.song.tags}
                        songUrl={href}
                        type={this.props.type}/>
                    <Divider/>
                    {/*<SongCardActions*/}
                        {/*songId={this.props.song.id}*/}
                        {/*upVote={this.props.upVote}*/}
                        {/*downVote={this.props.downVote}*/}
                        {/*voted={false}/>*/}
                    <Divider/>
                    {this.renderCardFooter()}
                </Card>
            </Paper>
        );
    }

    renderCardFooter() {
        if (this.props.type === 'songs') {
            return (
                <SongCardFooter
                    votes={this.props.song.votes}
                    comments={this.props.song.comments}
                    remixes={this.props.song.remixes}
                />
            );
        } else {
            return (
                <TrackCardFooter
                    votes={this.props.song.votes}
                    comments={this.props.song.comments}
                />
            );
        }
    }

    getDescription() {

        const description = this.props.song.description || "";
        const croppedDescription = description.substring(0, 200);

        if (croppedDescription.length < description.length)
            return `${croppedDescription}...`;

        return croppedDescription;
    }

    getHref() {
        if (this.props.type === 'songs') {
            return `/songs/${this.props.song.url}`;
        } else {
            return `/tracks/${this.props.song.url}`;
        }
    }
}

export default SongCard;



// WEBPACK FOOTER //
// ./components/songs/SongCard.tsx